import React from 'react';
import { useSearchParams } from 'react-router-dom';

import { GetPerformanceQuery, PerformanceMembersDataResponse } from '../types';
import { usePerformanceMembersRequest } from './usePerformanceRequests';

const useGetNetDischarge = (query?: GetPerformanceQuery) => {
    const [processedData, setProcessedData] =
        React.useState<PerformanceMembersDataResponse['net_discharge_rates']>();
    const { data } = usePerformanceMembersRequest(query);

    const [searchParams] = useSearchParams();
    const state = searchParams.get('state');

    React.useEffect(() => {
        if (!data) return;

        const filteredData = state
            ? data.net_discharge_rates.filter((item) => state.split(',').includes(item.state))
            : data.net_discharge_rates;

        const calculatedData = filteredData.reduce((acc, row) => {
            const existingWeek = acc.find(
                (item: PerformanceMembersDataResponse['net_discharge_rates'][number]) =>
                    item.week_start === row.week_start
            );

            if (existingWeek) {
                existingWeek.active_members_count += row.active_members_count;
                existingWeek.discharged_members += row.discharged_members;
            } else {
                acc.push({
                    state: '',
                    week_start: row.week_start,
                    week_end: row.week_end,

                    active_members_count: row.active_members_count,
                    discharged_members: row.discharged_members,

                    net_discharge_rate: -1
                });
            }

            return acc;
        }, [] as PerformanceMembersDataResponse['net_discharge_rates']);

        // Calculate percentages
        for (const row of calculatedData) {
            row.net_discharge_rate = (row.discharged_members / row.active_members_count) * 100 || 0;
        }

        calculatedData.sort(
            (a, b) => new Date(a.week_start).getTime() - new Date(b.week_start).getTime()
        );

        setProcessedData(calculatedData);
    }, [data, state]);

    return processedData || undefined;
};

export default useGetNetDischarge;
